// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".step-room{height:400px;margin-top:20px}.step-room .el-step.is-vertical{height:200px}.step-room .el-step__title.is-finish{color:#67c23a}.step-room .el-step__title.is-process{font-weight:700;color:#e6a23c}.step-room .el-step__title.is-wait{color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
